import { IconProps } from './Icon.types';
import icons from '../../assets/icons';
import { memo } from 'react';
import useStyle from '../../hooks/useStyle';

function Icon({ name, gradient, ...rest }: IconProps) {
  const style = useStyle(rest);
  const Icon = icons[name];

  return <Icon style={style} data-gradient={gradient} />;
}

export default memo(Icon);
